<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
  >
    <v-autocomplete
      v-if="customSlot"
      v-model="innerValue"
      :type="type"
      :prepend-icon="icon"
      :autofocus="autofocus"
      :class="`${customClass} ${requiredClassByRules()}`"
      :error-messages="errors"
      :hide-details="hideMessages"
      v-bind="$attrs"
      :clearable="clearable"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      v-on="$listeners"
    >
      <template slot="item" slot-scope="data">
        <slot name="item" v-bind="data"></slot>
      </template>
      <template slot="selection" slot-scope="data">
        <slot name="selection" v-bind="data"></slot>
      </template>
    </v-autocomplete>
    <v-autocomplete
      v-else
      v-model="innerValue"
      :type="type"
      :prepend-icon="icon"
      :autofocus="autofocus"
      :class="`${customClass} ${requiredClassByRules()}`"
      :error-messages="errors"
      :hide-details="hideMessages"
      v-bind="$attrs"
      :clearable="clearable"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      v-on="$listeners"
    >
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { validationMixin } from '../mixins/validation'

export default {
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
    vid: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    hideMessages: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    customSlot: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
